export const defaultNavigation = {
    prevEl: null,
    nextEl: null
};
